<template>
	<transition name="bounce">
		<v-card>
			<v-card-title class="py-1">Permissions</v-card-title>
			<v-card-text>
				<v-data-table :items="permissions" no-data-text="No permission attached to this user." :headers="headers" dense>
					<template v-slot:[`header.detach`]>
						<v-btn x-small class text outlined @click="detachAll" title="Remove all permissions from this user" v-if="permissions.length > 0">Detach all</v-btn>
					</template>
					<template v-slot:[`item.detach`]="{ item }">
						<td class="noprint" v-if="!item.role">
							<v-btn class="" small text @click="detachPermission(item)" title="Detach permission from user" :loading="detaching == item.id">
								Detach
							</v-btn>
						</td>
					</template>
				</v-data-table>
			</v-card-text>
			<v-card-actions class="py-0" v-show="undetachable.length > 0">
				Some permission can't be detached directly because they are attached to a role. To detach them, detach the role.
			</v-card-actions>
		</v-card>
	</transition>
</template>

<script>
	export default {
		name: 'UserPermissions',
		props: ['user'],
		data() {
			return {
				detaching: '',
				headers: [
					{
						text: 'Name', value: 'name'
					},
					{
						text: 'Description', value: 'label'
					},
					{
						text: 'Detach', value: 'detach', align: 'right', sortable: false
					}
				]
			}
		},
		methods: {
			detachPermission(permission) {
				swal({
					title: permission.name,
					text: 'Detach this permission from the user?',
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: 'red',
					confirmButtonText:'Ok',
					closeOnConfirm: false,
					showLoaderOnConfirm: true
				},
				function(){
					this.detaching = permission.id
					this.$inertia.post('/admin/permissions/' + permission.id + '/users/' + this.user.id + '/detach', {}, {
						preserveScroll: true,
						preserveState: true,
						onSuccess: () => {
							swal({ title: 'Detached', type: 'success', timer: 2500 })
						}
					})
				}.bind(this))
			},
			detachAll(){
				swal({
					title: 'Detach all permissions from <strong>'+this.user.email+'</strong>',
					html: true,
					type: 'warning',
					showCancelButton: true,
					confirmButtonColor: 'red',
					confirmButtonText:'Ok',
					closeOnConfirm: false,
					showLoaderOnConfirm: true
				},
				function(){
					this.$inertia.post('/admin/permissions/users/' + this.user.id + '/detach', {}, {
						preserveScroll: true,
						preserveState: false,
						onSuccess: () => {
							swal({title:'User striped of all permissions',type:'success',timer:1500})
							this.$emit('reloaduser')
						},
						onError: () => {
							swal('Error '+err.status+': '+err.statusText,'Failed to Remove permissions from user','error')
						}
					})
				}.bind(this))
			}
		},
		computed: {
			permissions() {
				var perms = this.user.permissions
				return _.uniqBy(perms, 'id')
			},
			undetachable () {
				return this.user.permissions.filter((perm) => {
					return perm.role
				})
			}
		}
	}
</script>
